import { getRegionConfig } from "@/lib/regionConfig";
import { DeliveryOrder } from "@/features/delivery/api/deliveryApi";

const TOKEN_KEY = "europcar_delivery_driver_token";
const regionConfig = getRegionConfig();

function apiUrl() {
  return regionConfig.apiUrl;
}

async function parseResponse<T>(response: Response): Promise<T> {
  const json = await response.json();

  if (!response.ok) {
    throw { ...json, status: response.status };
  }

  return json;
}

export function isUnauthenticated(err: unknown): boolean {
  return (err as { status?: number } | null)?.status === 401;
}

export function getDriverToken() {
  return window.localStorage.getItem(TOKEN_KEY);
}

export function clearDriverToken() {
  window.localStorage.removeItem(TOKEN_KEY);
}

export async function driverLogin(email: string, password: string) {
  const response = await fetch(`${apiUrl()}driver/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ email, password }),
  });
  const json = await parseResponse<{ token: string; driver: { id: number; name: string; email: string } }>(response);
  window.localStorage.setItem(TOKEN_KEY, json.token);

  return json;
}

export async function getDriverOrders() {
  const response = await fetch(`${apiUrl()}driver/orders`, {
    headers: { Authorization: `Bearer ${getDriverToken()}`, Accept: "application/json" },
  });

  return parseResponse<{ orders: DeliveryOrder[] }>(response);
}

export async function getDriverOrder(id: string) {
  const response = await fetch(`${apiUrl()}driver/orders/${id}`, {
    headers: { Authorization: `Bearer ${getDriverToken()}`, Accept: "application/json" },
  });

  return parseResponse<{ order: DeliveryOrder }>(response);
}

export async function driverOrderAction(id: number, action: "arrived" | "start-waiting" | "start-driving" | "complete" | "collected" | "returned-to-branch" | "no-show", body: Record<string, unknown> = {}) {
  const response = await fetch(`${apiUrl()}driver/orders/${id}/${action}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getDriverToken()}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(body),
  });

  return parseResponse<{ order: DeliveryOrder }>(response);
}
